/**
 * Mensagem a mostrar quando "Simular login" falha (F-23).
 *
 * Antes toda falha virava "Falha ao simular login". O server devolve o motivo
 * (usuário desativado, sem conta, conta congelada) num 400 `{ message }`, que o
 * `FetchUtil` lança como o próprio corpo JSON.
 */
export const FALHA_SIMULAR_LOGIN_PADRAO = 'Falha ao simular login';

export function mensagemDeFalhaAoSimular(e: unknown): string {
    if (!e || typeof e !== 'object') return FALHA_SIMULAR_LOGIN_PADRAO;
    const { message } = e as { message?: unknown };
    if (Array.isArray(message)) {
        const partes = message.filter((m): m is string => typeof m === 'string' && !!m.trim());
        if (partes.length) return `${FALHA_SIMULAR_LOGIN_PADRAO}: ${partes.join(' ')}`;
    }
    if (typeof message === 'string' && message.trim()) return `${FALHA_SIMULAR_LOGIN_PADRAO}: ${message.trim()}`;
    return FALHA_SIMULAR_LOGIN_PADRAO;
}
